const p1 = [
    [0, 6],
    [6, 6],
    [8, 2],
    [16, 2],
    [18, 6],
    [34, 6],
    [36, 2],
    [38, 2],
    [40, 6],
    [46, 6],
    [48, 10],
    [53, 10],
    [55, 10, true, 1], //branch point, trigger spark on pattern 1
    [74, 48],
    [49, 98, true, 2],
    [22, 98],
    [26, 90],
    [8, 90],
    [12, 98],
    [0, 98],
]

const p1b = [
    [53, 10],
    [55, 10],
    [51, 2],
    [100, 2]
]

const p1c = [
    [50, 98],
    [69, 98],
    [65, 90],
    [71, 90],
    [73, 94],
    [100, 94]
]

const p1d = [
    [54, 10],
    [55, 10],
    [56, 12],
]


const p2 = [
    [0, 2],
    [6, 2],
    [8, 6],
    [16, 6],
    [18, 2],
    [34, 2],
    [36, 6],
    [38, 6],
    [40, 2],
    [47, 2],
    [49, 6],
    [56, 6],
    [58, 10, true, 4],
    [74, 42],
    [51, 88, true, 5],
    [48, 94],
    [21, 94],
    [19, 98],
    [16, 98],
    [18, 94],
    [0, 94]
]

const p2b = [
    [58, 10],
    [61, 10],
    [59, 6],
    [100, 6],
]

const p2c = [
    [50, 90],
    [56, 90],
    [54, 94],
    [70, 94],
    [72, 98],
    [100, 98]
]

//first point gets skipped when erasing, redrawn as part of segment to ensure clean line joins
const x1 = [
    [3, 6],
    [6, 6],
    [8, 2],
    [9, 2],
];

const x2 = [
    [13, 6],
    [16, 6],
    [18, 2],
    [19, 2],
];

const x3 = [
    [33, 6],
    [34, 6],
    [36, 2],
    [37, 2]
];

const x4 = [
    [37, 6],
    [38, 6],
    [40, 2],
    [41, 2]
]

const x5 = [
    [56, 12],
    [51, 2],
    [100, 2]
]

const x6 = [
    [72, 38],
    [74, 42],
    [70, 50],
]

const x7 = [
    [55, 86],
    [51, 94],
]

const x8 = [
    [59, 94],
    [70, 94],
    [72, 98],
    [100, 98]
]

const x9 = [
    [25, 98],
    [22, 98],
    [26, 90],
    [20, 90],
]

const x10 = [
    [13, 94],
    [4, 94]
]

export const clippedPath = [
    [0, 6],
    [6, 6],
    [7, 4],
    [8, 6],
    [16, 6],
    [17, 4],
    [18, 6],
    [34, 6],
    [35, 4],
    [36, 6],
    [38, 6],
    [39, 4],
    [40, 6],
    [46, 6],
    [48, 10],
    [55, 10],
    [74, 48],
    [72, 46],
    [71, 48],
    // [56, 84],
    // [53, 84],
    [48, 94],
    [24, 94],
    [26, 90],
    [8, 90],
    [10, 94],
    [0, 94]
]

export const clipped2 = [
    [100, 94],
    [73, 94],
    [71, 90],
    [64, 90, true],
    [66, 94, true],
    [54, 94, true],
    [56, 90, true],
    [53, 90],
    [74, 48],
    [72, 45, true],
    [74, 42],
    [58, 10],
    [61, 10, true],
    [59, 6, true],
    [100, 6]
]

export default { p1, p1b, p1c, p1d, p2, p2b, p2c, x1, x2, x3, x4, x5, x6, x7, x8, x9, x10, clippedPath, clipped2 }